<script>
import { VBtn } from 'vuetify/lib';

export default {
  props: {
    ...VBtn.options.props,
  },
  render(createElement) {
    const customData = {
      props: {
        ...this.$props,
        ...this.$attrs,
      },
      class: ['b-button'],
      on: this.$listeners,
    }

    if (customData.props.color === undefined) {
      customData.props.color = 'primary';
    }

    return createElement(VBtn, customData, this.$slots.default);
  }
}
</script>

<style lang="scss">
.b-button {
  text-transform: none;
  color: #fff;
  font-weight: normal;
  &.fullsize {
    width: 100%;
  }
}
</style>
